import React from 'react';
import { Typography } from 'antd';
import './SimilarCarsSection.scss';

const { Text } = Typography;

interface SimilarCarsSectionProps {
    similarCars: Array<{
        Mileage: number;
        Price: number;
        Location: string;
        Name: string;
        Make: string;
        imageLink: string;
        Link: string;
        EndTime: number;
    }>;
    isMobile: boolean;
}

const SimilarCarsSection: React.FC<SimilarCarsSectionProps> = ({ similarCars, isMobile }) => {
    const formatMileage = (mileage: string | number): string => {
        let mileageStr = String(mileage).replace(/Miles|mi|,/gi, '').replace(/Shown/gi, '').trim();
        if (mileageStr.indexOf('k') > -1) {
            mileageStr = mileageStr.replace('k', '000');
        }
        const mileageNumber = Number(mileageStr);
        if (isNaN(mileageNumber)) {
            return String(mileage); // Return the original mileage value if conversion results in NaN
        }
        return `${mileageNumber.toLocaleString()} miles`;
    };
    
    const parseMileage = (mileage: string | number): number => {
        let mileageStr = String(mileage).replace(/Miles|mi|,/gi, '').replace(/Shown/gi, '').trim();
        if (mileageStr.indexOf('k') > -1) {
            mileageStr = mileageStr.replace('k', '000');
        }
        return parseInt(mileageStr, 10);
    };

    if (!similarCars || similarCars.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <Text type="secondary">No similar sold vehicles found.</Text>
            </div>
        );
    }
    
    return (
        <div className={`similar-cars-section ${isMobile ? 'mobile' : ''}`}>
            <div className={`similar-cars-grid ${isMobile ? 'mobile' : ''}`}>
                {similarCars.map((similarCar, index) => (
                    <div 
                        key={index} 
                        className="similar-car-card"
                    >
                        <img 
                            src={similarCar.imageLink} 
                            alt={similarCar.Name}
                            className="similar-car-image"
                        />
                        <div className="similar-car-info">
                            <div className="name">{similarCar.Name}</div>
                            <div className="price">${similarCar.Price.toLocaleString()}</div>
                            <div className="mileage">{formatMileage(similarCar.Mileage)}</div>
                            <div className="location">
                                sold {new Date(similarCar.EndTime*1000).toLocaleDateString('en-US', { 
                                    month: 'short', 
                                    day: 'numeric', 
                                    year: 'numeric' 
                                })}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SimilarCarsSection;
